var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cbs-objects-tbl',{attrs:{"meta-filter":"table","title":"DATA TABLES"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }